import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import axios from '../utils/axios'
import site from "../utils/SiteSettings"
import imageUrl from "../utils/imageUrl"

export const Footer = () => {

    // eslint-disable-next-line
    const [link, setLink] = useState([])
      
    const getLink = async () => {
        
        try {
            await axios.get("/link")
            .then((res)=>{
                let data = JSON.parse(res.data)
                // console.log(data)
                setLink(data)
            }).catch((err)=> {
            // setData(true)
            // setData1(false)
                console.log(err)}
            )
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(()=>{
        getLink()
        // eslint-disable-next-line
    },[])
// console.log(link)

  return (
    <>
        {/* <!-- footer section start--> */}
        <footer>
            <div className="container">
                <div className="footer-row">
                    <div className="footer-main">
                        <Link to="/" className="footer-logo">
                            {/* COINSTIRS */}
                            <img  src={require("../../assets/logo.png")} className="img-fluid robot-img" alt="robot" />
                        </Link>
                        {/* <h3>COMMUNITY ICONS</h3> */}
                        {/* <form>
                            <div className="input-group">
                                <input type="email" className="form-control" id="exampleFormControlInput1"
                                    placeholder="Enter your mail"/>
                                <a href data-cursor="pointer" className="btn-basic">Subscribe</a>
                            </div>
                        </form> */}
                        <ul className="social-links">
                            <li>
                                <a target='_blank' rel="noreferrer" data-cursor="pointer" active="true" href='https://www.facebook.com/'>
                                {/* <a target='_blank' rel="noreferrer" data-cursor="pointer" active="true" href='https://www.facebook.com/@ctpayofficial'> */}
                                    <img src={require("../../assets/icon/facebook.svg").default} className="img-fluid" alt="facebook"/>
                                </a>
                            </li>
                            <li>
                                <a target='_blank' rel="noreferrer" data-cursor="pointer" href='https://linktr.ee/'>
                                {/* <a target='_blank' rel="noreferrer" data-cursor="pointer" href='https://linktr.ee/ctpay'> */}
                                    <img src={require("../../assets/icon/linktree.svg").default} className="img-fluid" alt="linkedin"/>
                                </a>
                            </li>
                            <li>
                                <a target='_blank' rel="noreferrer" data-cursor="pointer" href='https://www.instagram.com/'>
                                {/* <a target='_blank' rel="noreferrer" data-cursor="pointer" href='https://www.instagram.com/ctpayofficial/'> */}
                                    <img src={require("../../assets/icon/instagram.svg").default}  className="img-fluid" alt="insta"/>
                                </a>
                            </li>
                            <li>
                                <a target='_blank' rel="noreferrer" data-cursor="pointer" href='https://x.com/' >
                                {/* <a target='_blank' rel="noreferrer" data-cursor="pointer" href='https://x.com/ctpayofficial' > */}
                                    <img src={require("../../assets/icon/twitter.svg").default} className="img-fluid" alt="twitter"/>
                                </a>
                            </li>
                            <li>
                                <a target='_blank' rel="noreferrer" data-cursor="pointer" href='https://www.youtube.com'>
                                {/* <a target='_blank' rel="noreferrer" data-cursor="pointer" href='https://www.youtube.com/@Ctpayofficial'> */}
                                    <img src={require("../../assets/icon/youtube.svg").default} className="img-fluid" alt="twitter"/>
                                </a>
                            </li>
                            <li>
                                <a target='_blank' rel="noreferrer" data-cursor="pointer" href="https://medium.com/">
                                {/* <a target='_blank' rel="noreferrer" data-cursor="pointer" href="https://medium.com/@ctpay"> */}
                                    <img src={require("../../assets/icon/medium.svg").default} className="img-fluid" alt="twitter"/>
                                </a>
                            </li>
                            <li>
                                <a target='_blank' rel="noreferrer" data-cursor="pointer" href="https://www.reddit.com">
                                {/* <a target='_blank' rel="noreferrer" data-cursor="pointer" href="https://www.reddit.com/r/ctpay"> */}
                                    <img src={require("../../assets/icon/reddit.svg").default} className="img-fluid" alt="twitter"/>
                                </a>
                            </li>
                        </ul>
                    </div>
                    {/* <div className="link-section">
                        <div className="footer-title">
                            <img src={require("../../assets/svg/home/star.svg").default} className="img-fluid" alt="star"/>
                            Quick Link
                        </div>
                        <div className="footer-content">
                            <ul>
                                <li data-cursor="pointer"><Link to={"/"}>Home</Link></li>
                                <li data-cursor="pointer"><Link to={""}>About Us</Link></li>
                                <li data-cursor="pointer"><Link to={""}>Tokenomics</Link></li>
                                <li data-cursor="pointer"><Link to={""}>Whitepaper</Link></li>
                            </ul>
                        </div>
                    </div> */}
                    <div className="link-section">
                        <div className="footer-title">
                            <img src={require("../../assets/svg/home/star.svg").default} className="img-fluid" alt="star"/>
                            Our service
                        </div>
                        <div className="footer-content">
                            <ul>
                                <li data-cursor="pointer"><Link to={"/wallet"}>Wallet</Link></li>
                                <li data-cursor="pointer"><Link to={"/buy/token"}>Buy {site?.site?.siteName}</Link></li>
                                <li data-cursor="pointer"><Link to={"/deposit"}>Deposit</Link></li>
                                <li data-cursor="pointer"><Link to={"/withdrawal"}>Withdraw</Link></li>
                            </ul>
                        </div>
                    </div>
                    <div className="link-section">
                        <div className="footer-title">
                            <img src={require("../../assets/svg/home/star.svg").default} className="img-fluid" alt="star"/>
                            Our company
                        </div>
                        <div className="footer-content">
                            <ul>
                                <li><Link data-cursor="pointer" to={"/login"}>Login</Link></li>
                                <li><Link data-cursor="pointer" to={"/login"}>Register </Link></li>
                                <li><Link target='_blank' data-cursor="pointer" to={`${imageUrl}/PIPAY_White_Paper.pdf`}>Whitepaper</Link></li>
                                <li><Link data-cursor="pointer" to={"/support"}>Support</Link></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="footer-copyright">
                    <h4>Copyright © 2025 {site?.site?.siteName}. All Rights Reserved.</h4>
                    <ul className="footer-links" style={{cursor:"pointer"}}>
                        <li><a target='_blank' rel="noreferrer" href={`${imageUrl}/PIPAY_Privacy_Policy.pdf`} >Privacy Policy </a></li>
                        <li><a target='_blank' rel="noreferrer" href={`${imageUrl}/PIPAY_Terms&condition.pdf`} >Terms & Condition </a></li>
                    </ul>
                </div>
            </div>
        </footer>
        {/* <!-- footer section end--> */}

    </>
  )
}
